











import { Component, Vue,Prop,Watch } from 'vue-property-decorator'
import { entComprehensiveEnergyConsumeRank } from '@/api/home'
const echarts = require('echarts')
import NoData from '@/components/NoData'
@Component({
  name: 'EnergyConsumption',
  components:{NoData}
})
export default class EnergyConsumption extends Vue {
     @Prop({default:''}) code!:string
    private data : any = []
  entComprehensiveEnergyConsumeRankData(e:any){
    entComprehensiveEnergyConsumeRank({
      regionCode:e,
      unitType:0
    }).then((res :any)=>{
      if(res.status == 0){
        this.data = []
        res.data.forEach((item:any) =>{
            this.data.push([item.enterpriseName,Number(item.comprehensiveEnergyConsumption) ])
        })
        this.init()
      }
    //   if(!res.data){
    //     this.data = null
    //   }
    }).catch(err =>{
    })
  }
  private init() {
      const main = document.getElementById('EnergyConsumption')
      // 基于准备好的dom，初始化echarts实例
      const myChart:any = echarts.init(main as HTMLDivElement)
      const this_ = this
      // 指定图表的配置项和数据
      const option = { 
        tooltip: {},
        grid: {
          top:'8%',
          // top:'6%',
          left: '0',
          // right: '2%',
          bottom: '3%',
          containLabel: true
        },
        yAxis:{
          type:'value',
          axisLabel:{
                textStyle: {
                    align:'right',
                    baseline:'middle'
                }
            }
        },
        xAxis: {
          type:'category',
          axisLabel: {
            interval: 0,
            formatter: function(value:any) {
                  let formatterres = value
                  if(this_.data.length == 5){
                    if(formatterres.length > 3) {
                        formatterres = formatterres.substring(0, 3) + '..'
                    }
                  }else if(this_.data.length == 4){
                      if(formatterres.length > 4) {
                          formatterres = formatterres.substring(0, 4) + '..'
                      }
                  }else if(this_.data.length == 3){
                      if(formatterres.length > 5) {
                          formatterres = formatterres.substring(0, 5) + '..'
                      }
                  }else if(this_.data.length == 2){
                      if(formatterres.length > 8) {
                          formatterres = formatterres.substring(0, 8) + '..'
                      }
                  }
                  return formatterres
              }
          }
        },
        series: [
          {
            barWidth:10,
            name: '',
            type: 'bar',
            itemStyle:{
              normal:{
                // label:{
                //   show:true,
                //   position:'right',
                //   textStyle:{color:'#000'}
                // },
                barBorderRadius: [5, 5, 5, 5],
              }
					  },
            data: this.data,
          }
        ],
      }
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option)
  }
  updatafun(){
    setTimeout(() => {
      this.init()
    }, 0)
  }
    @Watch('code')
    onChangeData(e:any) {
        this.entComprehensiveEnergyConsumeRankData(e)
    }
  mounted() {
    this.entComprehensiveEnergyConsumeRankData(this.code)
  }
}
